<div [formGroup]="searchForm" class="mb-3">
  <input type="text" formControlName="search" placeholder="{{ placeholder}}" class="form-control">
</div>